import axiosInstance from "../../axios/axiosInstance";

export const getAllDictionariesRequest = () => {
  return axiosInstance.get(`api/Common/GetDictionary`);
};
